import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../common/Modal';
import '../../styles/actionErrorModal.css';

/**
 * Blocking error dialog for action control failures (e.g. immediate watering
 * blocked by bounds). Success / in-progress status stays on the inline banner;
 * only errors use this modal so the user must dismiss with X.
 */
export default function ActionErrorModal({ isOpen, onClose, title = 'Action blocked', message }) {
    if (!message) return null;

    return (
        <Modal isVisible={isOpen} onClose={onClose}>
            <div className="action-error-modal" role="alertdialog" aria-labelledby="action-error-title" aria-describedby="action-error-message">
                <header className="action-error-header">
                    <i className="ri-error-warning-line action-error-icon" aria-hidden="true"></i>
                    <h3 id="action-error-title" className="action-error-title">{title}</h3>
                </header>
                <p id="action-error-message" className="action-error-message">{message}</p>
                <footer className="action-error-footer">
                    <button type="button" className="action-error-close-btn" onClick={onClose}>
                        Close
                    </button>
                </footer>
            </div>
        </Modal>
    );
}

ActionErrorModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    message: PropTypes.string,
};
